var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"create-button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('Icon',{attrs:{"name":"plus","size":32,"color":"primary"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }